__turbopack_context__.v({
  "emptyState": "GalleryGrid-module__oQP0SW__emptyState",
  "emptyTitle": "GalleryGrid-module__oQP0SW__emptyTitle",
  "fadeIn": "GalleryGrid-module__oQP0SW__fadeIn",
  "galleryGrid": "GalleryGrid-module__oQP0SW__galleryGrid",
  "galleryImage": "GalleryGrid-module__oQP0SW__galleryImage",
  "galleryItem": "GalleryGrid-module__oQP0SW__galleryItem",
  "gallerySection": "GalleryGrid-module__oQP0SW__gallerySection",
  "imageTitle": "GalleryGrid-module__oQP0SW__imageTitle",
  "lightbox": "GalleryGrid-module__oQP0SW__lightbox",
  "lightboxCaption": "GalleryGrid-module__oQP0SW__lightboxCaption",
  "lightboxClose": "GalleryGrid-module__oQP0SW__lightboxClose",
  "lightboxContent": "GalleryGrid-module__oQP0SW__lightboxContent",
  "lightboxImage": "GalleryGrid-module__oQP0SW__lightboxImage",
  "loaderContainer": "GalleryGrid-module__oQP0SW__loaderContainer",
  "overlay": "GalleryGrid-module__oQP0SW__overlay",
  "overlayIcon": "GalleryGrid-module__oQP0SW__overlayIcon",
  "overlayIconWrapper": "GalleryGrid-module__oQP0SW__overlayIconWrapper",
  "rotate": "GalleryGrid-module__oQP0SW__rotate",
  "sentinel": "GalleryGrid-module__oQP0SW__sentinel",
  "shimmer": "GalleryGrid-module__oQP0SW__shimmer",
  "skeleton": "GalleryGrid-module__oQP0SW__skeleton",
  "skeletonCard": "GalleryGrid-module__oQP0SW__skeletonCard",
  "spinner": "GalleryGrid-module__oQP0SW__spinner",
});
